import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SelectDropdown from '../../../../SelectDropdown/SelectDropdown';
import {labels} from '../../../../../../util/utils';
import Chip from '../../../../BaseComponentWrappers/MotifChip';
import Button from '../../../../BaseComponentWrappers/MotifButton';
import ProgressBar from '../../../../BaseComponentWrappers/MotifProgressBar';
import Checkbox from '../../../../BaseComponentWrappers/MotifCheckbox';
import Ellipses from '../../../../EllipsesControl/EllipsesPresets';

export default function AssertionSelect(props) {
	const {
		options,
		showErrorMessage,
		errorMessage,
		openEditAccountModalHandler,
		onOptionChecked,
		showLoader,
		onChange,
		isDisabled,
		isFooterEnabled
	} = props;
	const [assertionSelectLabel, setAssertionSelectLabel] = useState(labels.selectAssertions),
		[assertionSelectedValues, setAssertionSelectedValues] = useState([]);

	const optionCheckChanged = (option) => {
		let currentlySelected = _.cloneDeep(assertionSelectedValues);
		const found = currentlySelected.find((options) => options.id === option.id);
		if (found) {
			currentlySelected = currentlySelected.filter((options) => options.id !== option.id);
		} else {
			currentlySelected.push(option);
		}
		setAssertionSelectedValues(currentlySelected);
		option.isSelected = !option.isSelected;
		onOptionChecked && onOptionChecked(option);
	};

	const formatOptionsLabel = (option, context) => {
		if (context.context === 'menu') {
			return (
				<AssertionOptionWrapper
					key={`option__${option.id}`}
					onClick={() => optionCheckChanged(option)}
					className={`assertions-option ${option.isSelected ? 'selected' : ''}`}
				>
					<Checkbox checked={option.isSelected} className="assertion-checkbox" />
					<section className="assertionsname-wrapper">
						<Chip title={option.label} label={option.assertionAbbreviation} />
						<Ellipses.Single content={option.label} tooltip={option.label} />
					</section>
				</AssertionOptionWrapper>
			);
		}
		return (
			<Chip
				style={option.isSelected ? {} : {visibility: 'hidden'}}
				title={option.label}
				disabled={isDisabled}
				label={option.assertionAbbreviation}
			/>
		);
	};

	const openEditAccountModal = () => {
		if (openEditAccountModalHandler) {
			openEditAccountModalHandler();
		}
	};

	const footer = (
		<section className="editaccount-wrapper">
			<Button
				variant="text-alt"
				className="edit-account"
				onClick={openEditAccountModal}
				showLabel
				buttonLabel={labels.editAccount}
			/>
		</section>
	);

	useEffect(() => {
		if (options.length > 0) {
			const selected = options.filter((option) => option.isSelected);
			setAssertionSelectLabel(selected?.length > 0 ? labels.relatedAssertions : labels.selectAssertions);
			setAssertionSelectedValues(selected);
		}
	}, [options]);

	return (
		<StyledAssertionSelect className="assertions-wrapper">
			{showLoader && (
				<section className="greyOutArea MotifProgressBarWrapper">
					<ProgressBar isIndeterminate showLabel labelComponent={<span>{labels.saving}</span>} />
				</section>
			)}
			<SelectDropdown
				className={showLoader ? 'assertions-dropdown' : 'assertions-dropdown'}
				closeMenuOnSelect={false}
				formLabel={assertionSelectLabel}
				id="assertions"
				isMulti
				isSearchable={false}
				noOptionsMessage={() => labels.noAssertionsIdentifiedForAccount}
				isClearable={false}
				value={assertionSelectedValues}
				options={options}
				hideSelectedOptions={false}
				onChange={onChange ? onChange : () => {}}
				isDisabled={isDisabled}
				formatOptionLabel={formatOptionsLabel}
				footer={isFooterEnabled ? footer : null}
				showErrorMessage={showErrorMessage}
				errorMessage={errorMessage}
			/>
		</StyledAssertionSelect>
	);
}

AssertionSelect.propTypes = {
	onChange: PropTypes.func,
	isDisabled: PropTypes.bool,
	isFooterEnabled: PropTypes.bool,
	showErrorMessage: PropTypes.bool,
	errorMessage: PropTypes.string
};

const AssertionOptionWrapper = styled.section`
	display: flex;
	align-items: center;
	gap: var(--px-10);
	padding: 0;
`;

const StyledAssertionSelect = styled.section`
	display: inline-block;
	width: 35%;
	.assertions-dropdown {
		display: inline-block;
		width: 100%;
		vertical-align: bottom;
		&.loader {
			.react-select__menu {
				pointer-events: none;
				.react-select__menu-list,
				.editaccount-wrapper {
					opacity: 0.3;
					pointer-events: none;
				}
			}
		}
		&.select-error {
			.show {
				position: absolute;
			}
		}
		.react-select-container .react-select__multi-value {
			border-radius: 0;
			background-color: transparent;
			.react-select__multi-value__label {
				border-radius: 0;
				&:first-child {
					padding-left: 0;
					padding-bottom: 0;
				}
				.motif-chip {
					height: var(--px-18);
					.motif-chip-button {
						height: 100%;
						width: var(--px-42);
						justify-content: center;
					}
				}
			}
			.react-select__multi-value__remove {
				display: none;
			}
		}
		.react-select-container .react-select__menu .react-select__menu-notice--no-options {
			padding: var(--px-25) var(--px-10);
		}
		.react-select-container .react-select__menu .react-select__menu-list .react-select__option {
			cursor: default;
			padding-top: var(--px-10);
			padding-bottom: var(--px-10);
			.motif-chip {
				margin-right: var(--px-10);
				height: var(--px-18);
				.motif-chip-button {
					width: var(--px-42);
					justify-content: center;
				}
			}
		}
		.assertions-option {
			display: flex;
			.StyledMotifCheckbox {
				display: flex;
				align-items: center;
			}
			.assertionsname-wrapper {
				display: flex;
				align-items: center;
				width: 75%;
				height: var(--px-18);
				@media only screen and (min-width: 1280px) and (max-width: 1366px) {
					width: 62%;
				}
				.assertions-name {
					display: block;
					width: 100%;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}
			}
		}
		.editaccount-wrapper {
			background: var(--neutrals-00white);
			border-top: var(--px-1) solid var(--neutrals-300);
			.edit-account {
				margin: var(--px-12) var(--px-14);
			}
		}
	}
`;
